import * as taskName from './task-name'
import { createUIDefinition } from '../default-task-definition'

export default createUIDefinition({
    taskName: taskName.MAKE_CUSTOMER_APPOINTMENT,
    widgetList: [],
})



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/set-and-shop-scan/make-customer-appointment.js